import { NAVI_SUBSCRIBE } from "@/graphql/navi.graphql";
import useTranslation from "@/hooks/useTranslation";
import { currentUserState, routerState } from "@/stores/common";
import { naviState } from "@/stores/navi";
import { shortUUID } from "@/utils/string.util";
import { useMutation } from "@apollo/react-hooks";
import { Button, ButtonGroup } from "@material-ui/core";
import { message } from "antd";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import AddSubDialog from "./AddSubDialog";

const Feature: React.FC = () => {
  const router = useRouter();
  const { t } = useTranslation("explore");
  const { status } = useRecoilValue(currentUserState);
  const setRouterState = useSetRecoilState(routerState);
  const { searchParams, id } = useRecoilValue(naviState);
  const [subscribe, { loading }] = useMutation<
    { addSubscriber: string },
    {
      add: {
        id: string;
        description: string;
        public: boolean;
        name: string;
      };
    }
  >(NAVI_SUBSCRIBE);
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => setOpen(false);

  const handleSubmit = async (props: {
    id: string;
    description: string;
    public: boolean;
    name: string;
  }) => {
    const { data } = await subscribe({ variables: { add: props } });
    if (data) {
      message.success(t("navi.subscribe.success"));
      router.push(
        "/bundle/subscription/[id]",
        `/bundle/subscription/${shortUUID(data?.addSubscriber)}`
      );
      handleClose();
    }
  };

  return (
    <>
      <ButtonGroup>
        <Button
          variant="outlined"
          color="primary"
          onClick={() =>
            router.push(
              "/explore/navi/[id]/introspection",
              `/explore/navi/${router.query.id}/introspection`
            )
          }
        >
          {t("navi.introspect.report")}
        </Button>
        <Button
          variant="outlined"
          color="default"
          onClick={() => {
            if (!status) {
              message.error(t("common:status.one"));
              setRouterState({ redirect: router.asPath });
              setTimeout(() => router.push("/auth/login"), 500);
            } else if (status === 1) {
              message.error(t("common:status.two"));
              setTimeout(() => router.push("/user/settings"), 500);
            } else {
              setOpen(true);
            }
          }}
        >
          {t("navi.subscribe.create")}
        </Button>
      </ButtonGroup>
      <AddSubDialog
        id={id}
        handleSubmit={handleSubmit}
        open={open}
        handleClose={handleClose}
        term={searchParams?.term}
        loading={loading}
      />
    </>
  );
};

export default Feature;
